import { Dispatch } from "redux";
import { toast } from "react-toastify";

import { LOADER_START, LOADER_STOP } from "../types";
import Client from "../../components/apollo/Client";
import {
  deletePortalUserInvitation,
  deleteUserFromOrganization,
} from "../../api/organizations";
import { GET_PORTAL_USERS_INFO, GET_USER } from "../../api/gqlQueries";
import { NavigateContextType } from "../../NavigationContext";

export const cancelPortalUserInvite =
  (
    emailAddress: string | null,
    propertyId: string | undefined,
    refetch: () => void
  ) =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch({
      type: LOADER_START,
    });
    if (propertyId === undefined) {
      propertyId = "";
    }
    await deletePortalUserInvitation(
      propertyId,
      emailAddress,
      dispatch,
      () => {
        dispatch({
          type: LOADER_STOP,
        });
        refetch();
      },
      () => {
        dispatch({
          type: LOADER_STOP,
        });
        return false;
      }
    );
  };

export const removePortalUser =
  (
    propertyId: string | undefined,
    userId: string,
    navigate: NavigateContextType
  ) =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch({
      type: LOADER_START,
    });
    if (propertyId === undefined) {
      propertyId = "";
    }
    await deleteUserFromOrganization(
      propertyId,
      userId,
      dispatch,
      async () => {
        dispatch({
          type: LOADER_STOP,
        });
        await Client.refetchQueries({
          include: [GET_PORTAL_USERS_INFO, GET_USER],
        });
        navigate("/");
        toast("Manager Removed");
      },
      () => {
        dispatch({
          type: LOADER_STOP,
        });
        return false;
      }
    );
  };
